import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import {
  logOut
} from '../../actions/appealActions'
import PropTypes from 'prop-types'

class ConfirmEmail extends Component {
  constructor (props) {
    super(props)
    console.log(props)
  }

  componentWillMount () {
    if (!this.props.register_data) {
      this.props.logOut()
    }
  }
  render () {
    if (this.props.register_data) {
      return (

        <div>
          <Container>
            <Row>
              <Col>
                <h1>We've sent you a confirmation email</h1>
                <p>We sent an email to <b>{this.props.register_data.email}</b>.</p>
                <p>In this email you will find a link that, when clicked, will take you to your appeal.</p>
                <p>If you entered an incorrect email address, please go back and register again.</p>
                <p>If for some reason you did not receive the confirmation email, feel free to get in touch and we'll do our best to get you sorted.</p>
                <p>PLEASE check your junk/spam folder before contacting us, as it is very common to have email delivery problems because of automated filters. </p>
              </Col>
            </Row>
          </Container>
        </div>
      )
    } else {
      return null
    }
  }
}

ConfirmEmail.propTypes = {
  register_data: PropTypes.object,
  logOut: PropTypes.func
}

const mapStateToProps = ({ appeal }) => ({
  register_data: appeal.register_data
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logOut
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmEmail))



// WEBPACK FOOTER //
// ./src/containers/confirmemail/index.jsx